import { Stack, StackProps, styled, Typography } from '@mui/material';

import Image from '../../../../../../../components/Image';
import { buttonAsDiv } from '../../../../../../../styles/mixins';
import { generateClasses } from '../../../../../../../utils/helpers';
import CommentActions from './CommentActions';
import CommentStatsButton from './CommentStatsButton';

export const commentClasses = {
  ...generateClasses('Comment', [
    'clickable',
    'fakeCommentArea',
    'isFirstComment',
    'actions',
    'alignActionsWithCreator',
  ]),
};

export const Root = styled((props: StackProps) => (
  <Stack direction="column" alignItems="flex-start" gap={4} {...props} />
))(({ theme }) => ({
  position: 'relative',
  [`&.${commentClasses.clickable}`]: {
    cursor: 'pointer',
  },
  [`& .${commentClasses.fakeCommentArea}`]: {
    position: 'absolute',
    // top and bottom gap around item + left and right padding around group
    inset: theme.spacing(-3),
    [`&.${commentClasses.isFirstComment}`]: {
      top: 'unset',
      // 100% height of comment + gap between user cell and comment + (40px) height of user cell + top padding of group and bottom gap between comments
      height: `calc(100% + ${theme.spacing(4)} + 40px + ${theme.spacing(6)})`,
    },
  },
  '&:hover': {
    [`& .${commentClasses.actions}`]: {
      display: 'flex',
    },
  },
}));

export const Actions = styled(CommentActions)<{ forceDisplay?: boolean }>(({ theme, forceDisplay }) => {
  if (forceDisplay) {
    return {
      display: 'flex',
    };
  }

  return {
    position: 'absolute',
    top: theme.spacing(0),
    right: theme.spacing(0),
    zIndex: 100,
    display: 'none',
    // adjust to look centered with first line of text
    transform: 'translateY(-25%)',
    [`&.${commentClasses.alignActionsWithCreator}`]: {
      // adjust to see at the top
      transform: 'translateY(-150%)',
    },
  };
});

export const RemovedCommentContent = styled(Typography)(({ theme }) => ({
  fontStyle: 'italic',
  color: theme.palette.grey[600],
}));

export const ImageButton = styled('button')(({ theme }) => ({
  ...buttonAsDiv,
  maxWidth: '100%',
  width: '100%',
  maxHeight: 300,
}));

export const StyledImage = styled(Image)(({ theme }) => ({
  objectFit: 'cover',
  maxWidth: '100%',
  minHeight: 300,
}));

export const StyledCommentStatsButton = styled(CommentStatsButton)(({ theme }) => ({
  /** adjust top margin to neglect impact of gap between items */
  marginTop: `calc(-1 * (${theme.spacing(3)} - 1px))`,
  /** adjust bottom margin to neglect impact of padding on parent */
  marginBottom: `calc(-1 * (${theme.spacing(3)} - 1px))`,
}));
